(() => {
  const init = () => {
    document.querySelectorAll('[data-drilldown]').forEach((root) => {
      const track = root.querySelector('[data-drilldown-track]');
      const level1 = root.querySelector('[data-level="1"]');

      let currentKey = null;

const open = (key) => {
  currentKey = key;

  level1.querySelectorAll('[data-parent]').forEach((el) => {
    el.classList.toggle('is-visible', el.dataset.parent === key);
  });

  track.style.setProperty('--drill-pos', 1);
};

const back = () => {
  track.style.setProperty('--drill-pos', 0);
  currentKey = null;

  level1.querySelectorAll('[data-parent]').forEach((el) => {
    el.classList.remove('is-visible');
  });
};

      root.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-open]');
        if (btn) {
          e.preventDefault();
          open(btn.dataset.key);
          return;
        }

        const backBtn = e.target.closest('[data-back]');
        if (backBtn) {
          e.preventDefault();
          back();
        }
      });
    });
  };

  document.addEventListener('DOMContentLoaded', init);
})();